import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import "../styles/breadcrumbs.css"; // Ensure to use this file for custom styling

const breadcrumbNameMap = {
  adminJaya: "Admin Jaya",
  manageUser: "Manage User",
  resultPsikotesUser: "Psikotes Result",
  detailRes: "Detail",
};

const Breadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const isDetailResPage = pathnames.includes("detailRes");

  const uidIndex = pathnames.indexOf("detailRes") + 1;
  const uid = isDetailResPage && uidIndex < pathnames.length ? pathnames[uidIndex + 1] : "";

  const customBreadcrumbs = isDetailResPage
    ? [
        { to: "/adminJaya", label: "Admin Jaya" },
        { to: "/adminJaya/resultPsikotesUser", label: "Psikotes Result" },
        { to: "#", label: uid }, 
      ]
    : [];

  return (
    <Breadcrumb className="custom-breadcrumb-admin">
      {customBreadcrumbs.length > 0
        ? customBreadcrumbs.map((crumb, index) => (
            <Breadcrumb.Item
              key={crumb.to}
              linkAs={Link}
              linkProps={{ to: crumb.to }}
              className={`custom-breadcrumb-item py-2 px-2 ${
                index === customBreadcrumbs.length - 1 ? " active" : ""
              }`}
            >
              {crumb.label}
            </Breadcrumb.Item>
          ))
        : pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join("/")}`;
            
            // Check for specific pages and adjust breadcrumb accordingly
            if (value === "manageUser" || value === "resultPsikotesUser") {
              return (
                <React.Fragment key={to}>
                  <Breadcrumb.Item
                    linkAs={Link}
                    linkProps={{ to: "/adminJaya/dashboard" }}
                    className="custom-breadcrumb-item py-2 px-2"
                  >
                    Dashboard
                  </Breadcrumb.Item>
                  <Breadcrumb.Item
                    linkAs={Link}
                    linkProps={{ to }}
                    className={`custom-breadcrumb-item py-2 px-2 ${
                      index === pathnames.length - 1 ? " active" : ""
                    }`}
                  >
                    {breadcrumbNameMap[value] ||
                      value.charAt(0).toUpperCase() + value.slice(1)}
                  </Breadcrumb.Item>
                </React.Fragment>
              );
            }

            return (
              <Breadcrumb.Item
                key={to}
                linkAs={Link}
                linkProps={{ to }}
                className={`custom-breadcrumb-item py-2 px-2 ${
                  index === pathnames.length - 1 ? " active" : ""
                }`}
              >
                {breadcrumbNameMap[value] ||
                  value.charAt(0).toUpperCase() + value.slice(1)}
              </Breadcrumb.Item>
            );
          })}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
